import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

// 🔹 هذا الباث للملفات (صور + مرفقات)
export const FILE_BASE_URL = process.env.REACT_APP_FILE_URL || "http://localhost:8000/storage";

// إنشاء axios instance
const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000,
});

// إضافة token تلقائياً
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;

// اعتراض الأخطاء العامة
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        const url = error?.config?.url || '';
        const data = error?.response?.data;

        // 401: غير مصرح (جلسة منتهية/توكن غير صالح)
        if (status === 401) {
            // ✅ Clear all auth data on 401
            localStorage.removeItem('auth_token');
            localStorage.removeItem('authUser');
            localStorage.removeItem('user');
            localStorage.removeItem('role');

            // ✅ Only redirect if not already on login page
            if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
            return Promise.reject(error);
        }

        // 403: نُميز بين حظر IP وبين منع صلاحيات
        if (status === 403) {
            const isIpBlocked = (data && data.allowed === false) ||
                (typeof data?.message === 'string' && data.message.toLowerCase().includes('ip not whitelisted')) ||
                url.endsWith('/ip-check');

            if (isIpBlocked) {
                // ✅ For IP check endpoint, don't redirect - let IpGate component handle it
                if (url.endsWith('/ip-check')) {
                    return Promise.reject(error);
                }
                
                // ✅ For other blocked endpoints, redirect once only
                if (typeof window !== 'undefined' && window.location.pathname !== '/blocked') {
                    window.location.href = '/blocked';
                }
                return Promise.reject(error);
            }
            // لغير ذلك (صلاحيات/أدمن فقط)، لا نعيد التوجيه للبلوكد، بل نترك الخطأ للواجهة تتعامل معه
        }

        return Promise.reject(error);
    }
);